import DailyMotion from '../app/components/svg/socials/DailyMotion';
import Facebook from '../app/components/svg/socials/Facebook';
import FacebookColored from '../app/components/svg/socials/FacebookColored';
import Instagram from '../app/components/svg/socials/Instagram';
import InstagramColored from '../app/components/svg/socials/InstagramColored';
import Linkedin from '../app/components/svg/socials/Linkedin';
import LinkedinColored from '../app/components/svg/socials/LinkedinColored';
import Pinterest from '../app/components/svg/socials/Pinterest';
import Snapchat from '../app/components/svg/socials/Snapchat';
import Telegram from '../app/components/svg/socials/Telegram';
import TelegramColored from '../app/components/svg/socials/TelegramColored';
import Threads from '../app/components/svg/socials/Threads';
import TikTokk from '../app/components/svg/socials/Tiktokk';
import Whatsapp from '../app/components/svg/socials/Whatsapp';
import WhatsappColored from '../app/components/svg/socials/WhatsappColored';
import X from '../app/components/svg/socials/X';
import XColored from '../app/components/svg/socials/XColored';
import Youtube from '../app/components/svg/socials/Youtube';
import YoutubeColored from '../app/components/svg/socials/YoutubeColored';


export const socialIcons = [
  {
    Component: X,
    ShareComponent: XColored,
    type: 3,
    getShareLink: (url: string) => `https://x.com/share?url=${url}`,
    eremNewsLink: '',
    title: 'X'
  },
  {
    Component: Facebook,
    ShareComponent: FacebookColored,
    type: 2,
    getShareLink: (url: string) => `https://www.facebook.com/share.php?u=${url.replace('https://', '').replace('http://', '')}`,
    eremNewsLink: '',
    title: 'Facebook'
  },
  {
    Component: Instagram,
    ShareComponent: InstagramColored,
    type: 1,
    getShareLink: (url: string) => `https://www.instagram.com/?url=${url}`,
    eremNewsLink: '',
    title: 'Instagram'
  },
  {
    Component: Youtube,
    ShareComponent: YoutubeColored,
    type: 4,
    getShareLink: (url: string) => ``,
    eremNewsLink: '',
    title: 'Youtube'
  },
  {
    Component: Telegram,
    ShareComponent: TelegramColored,
    type: 9,
    getShareLink: (url: string) => `https://t.me/share/url?url=${url}`,
    eremNewsLink: '',
    title: 'Telegram'
  },
  {
    Component: Whatsapp,
    ShareComponent: WhatsappColored,
    type: 7,
    getShareLink: (url: string) => `https://api.whatsapp.com/send?text=${url}`,
    eremNewsLink: '',
    title: 'Whatsapp'
  },
  {
    Component: Linkedin,
    ShareComponent: LinkedinColored,
    type: 6,
    getShareLink: (url: string) => `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    eremNewsLink: '',
    title: 'Linkedin'
  },
  {
    Component: TikTokk,
    ShareComponent: TikTokk,
    type: 5,
    getShareLink: (url: string) => ``,
    eremNewsLink: '',
    title: 'TikTok'
  },
  {
    Component: Pinterest,
    ShareComponent: Pinterest,
    type: 8,
    getShareLink: (url: string) => ``,
    eremNewsLink: '',
    title: 'Pinterest'
  },
  {
    Component: Snapchat,
    ShareComponent: Snapchat,
    type: 10,
    getShareLink: (url: string) => ``,
    eremNewsLink: '',
    title: 'Snapchat'
  },
  {
    Component: Threads,
    ShareComponent: Threads,
    type: 11,
    getShareLink: (url: string) => ``,
    eremNewsLink: '',
    title: 'Threads'
  },
  {
    Component: DailyMotion,
    ShareComponent: DailyMotion,
    type: 12,
    getShareLink: (url: string) => ``,
    eremNewsLink: '',
    title: 'Dailymotion'
  },

]


enum SocialType {
  Others = 0,
 Instagram = 1,
 Facebook = 2,
 Twitter = 3,
 Youtube = 4,
 Tiktok = 5,
 Linkedin = 6,
 Whatsapp = 7,
 Telegram = 9
}